import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router';
import {
    EditOutlined,
} from '@ant-design/icons';
import {
    Table,
    // Button,
    Switch,
    Dropdown,
} from "antd";

// Constant
import { TEMPLATE } from '../../../../../../constants'

// Services
import { REDUX, TIME } from '../../../../../../services/util'

// Redux Actions 
import * as REDUX_ACTIONS from '../../../../../../services/redux/actions'

const {
    EVENT_TICKET_TYPES_BY_CODES
} = TEMPLATE.STATUS

const RuleEngineTable = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const ruleTemplates = useSelector(REDUX.reduxStoreWrapper('ruleTemplates'))
    const rules = useSelector(REDUX.reduxStoreWrapper('rules'))
    const uid = useSelector(REDUX.reduxStoreWrapper('user.uid'))

    const RTDataSrc = Object.values(ruleTemplates.byID).map((currRuleTemplate) => {

        return {
            key: currRuleTemplate.ruletid,
            ruletid: currRuleTemplate.ruletid,
            createdAt: currRuleTemplate.createdAt,
            numRules: (currRuleTemplate.rules && currRuleTemplate.rules.length) || 0,
            name: `${currRuleTemplate.name}`,
            // recipients: currRuleTemplate.recipients || [{ uid: currRuleTemplate.updatedBy }],
            recipients: currRuleTemplate.recipients || [{ uid: '' }],
            notificationType: currRuleTemplate.notificationType,
            status: currRuleTemplate.status ? true : false,
            default: currRuleTemplate.default || 0
        }
    })

    const editRuleOnClick = (data) => {
        navigate(`/update/rule`, {state: { data: { ...data, status: data.status ? 1 : 0, title: 'Edit' } }})
    }

    const editRuleTemplateOnClick = (data) => {
        navigate(`/update/ruletemplate`, {state: { data: { ...data, status: data.status ? 1 : 0, title: 'Edit' } }})
    }

    const deleteRuleTemplateOnClick = (ruletid) => {
        dispatch(REDUX_ACTIONS.v3_ruleTemplates.delete_rule_template_request(ruletid))
    }

    const changeStatusRuleHDLR = (status, data) => {

        dispatch(REDUX_ACTIONS.v3_rules.update_rule_request({
            name: data.name,
            type_rule: data.type_rule,
            ruletid: data.ruletid,
            conditions: data.conditions || [{}],
            ruleid: data.ruleid,
            status: status ? 0 : 1,
            uid: uid
        }))
        
    }

    const changeStatusRTHDLR = (status, data) => {

        dispatch(REDUX_ACTIONS.v3_ruleTemplates.update_rule_template_request({
            name: data.name,
            ruletid: data.ruletid,
            recipients: data.recipients || [{ uid: '' }],
            notificationType: data.notificationType || 'PUSH',
            status: status ? 0 : 1,
            uid: uid
        }))
        
    }

    const expandedRuleRowsRender = (record) => {
        const columnsRule = [
            {
                title: "Rule Name",
                dataIndex: "name",
            },
            {
                title: "Status",
                dataIndex: "status",
                render: (status, data) =>  
                    <Switch 
                        value={status} 
                        onChange={(e) => {
                            e && !record.status && changeStatusRTHDLR(record.status, record)
                            changeStatusRuleHDLR(status, { ...data, ruletid: record.ruletid })
                        }}
                    />
            },
            {
                title: "Type",
                dataIndex: "type_rule",
                render: code => EVENT_TICKET_TYPES_BY_CODES[code]
            },
            {
                title: "Parameters",
                dataIndex: "parameters",
            },
            {
                title: "Creation Date",
                dataIndex: "createdAt",
                render: datetime => TIME.parseTime(datetime),
            },
            {
                title: "Actions",
                // dataIndex: "ruleid",
                // render: (data) => {
                //     return (
                //         // !data.default
                //         // &&
                //         <Button.Group>
                //             <button className = "transparent-button">
                //                 <EditOutlined 
                //                     onClick = {() => editRuleOnClick(data)}
                //                 />
                //             </button>
                //         </Button.Group>
                //     )
                // },

                render: (data) => {

                    const items = [
                        {
                            key: '1',
                            label: 
                                <span 
                                    className="ButtonLink"
                                    aria-hidden="true"
                                    onClick = {() => editRuleOnClick(data)}
                                >
                                    Edit
                                </span>
                        },
                        !data.default && {
                            key: '2',
                            label: 
                                <span 
                                    className="ButtonLink"
                                    aria-hidden="true"
                                    onClick = {() => {}}
                                >
                                    Delete
                                </span>
                        },
                    ]
    
                    return (
                        // !data.default
                        // &&
                        <Dropdown menu={{ items }}>
                            <EditOutlined />
                        </Dropdown>
                    )
                }
            }
        ]

        const ruleArr = 
        ruleTemplates.byID[record.key]
        &&
        ruleTemplates.byID[record.key].rules?.map(ruleid => ({
            key: ruleid,
            ruleid: ruleid,
            ruletid: rules.byID[ruleid]?.ruletid,
            name: rules.byID[ruleid]?.name,
            status: rules.byID[ruleid]?.status ? true : false,
            type_rule: rules.byID[ruleid]?.type_rule,
            createdAt: rules.byID[ruleid]?.createdAt,
            parameters: `${rules.byID[ruleid]?.conditions.map(c => c.parameter)}`,
            conditions: rules.byID[ruleid]?.conditions || [{}],
            name_violated: rules.byID[ruleid]?.name_violated,
            name_compiled: rules.byID[ruleid]?.name_compiled,
            buzzer: rules.byID[ruleid]?.buzzer,
            buzzer_duration: rules.byID[ruleid]?.buzzer_duration,
            default: ruleTemplates.byID[record.key]?.default || 0
        }))
        ||
        []

        return <Table bordered columns = {columnsRule} dataSource = {ruleArr} pagination = {false} />
    }

    const columnsRuleTemplate = [
        {
            title: "Template Name",
            dataIndex: "name",
            render: (name, data) => `${name} (${data.numRules || 0})`
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (status, data) => <Switch value={status} onChange={() => changeStatusRTHDLR(status, data)} />
        },
        {
            title: "Rules",
            dataIndex: "numRules"
        },
        {
            title: "Creation Date",
            dataIndex: "createdAt",
            render: datetime => TIME.parseTime(datetime),
        },
        {
            title: "Actions",
            // dataIndex: 'default',
            render: (data) => {

                const items = [
                    {
                        key: '1',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => editRuleTemplateOnClick(data)}
                            >
                                Edit
                            </span>
                    },
                    {
                        key: '2',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => deleteRuleTemplateOnClick(data.ruletid)}
                            >
                                Delete
                            </span>
                    },
                ]

                return (
                    !data.default
                    &&
                    <Dropdown menu={{ items }}>
                        <EditOutlined />
                    </Dropdown>
                )
            }
        }
    ]

    return (
        <Table
            dataSource = {RTDataSrc}
            columns = {columnsRuleTemplate}
            expandable = {{
                // rowExpandable: (record) => !record.default,
                expandedRowRender: (record) => expandedRuleRowsRender(record),
            }}
        />
    )
}

export default RuleEngineTable